
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TrendCard',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    roundedCorners: {
      type: Boolean,
      default: true
    },
    showAccent: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'cherry'
    }
  },
  computed: {
    wrapperClass(): string {
      if (this.showBorder) {
        return 'rounded-r-md border-l-0'
      }
      return 'rounded-md'
    }
  }
})
